import { requirementCourseEnrollmentContract } from "@clipboard-health/contract-backend-main";
import { get } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { useQuery } from "@tanstack/react-query";
import { type z } from "zod";

const { 200: listCourseEnrollmentsResponseSchema } =
  requirementCourseEnrollmentContract.listRequirementCourseEnrollments.responses;

export type ListCourseEnrollmentsResponse = z.infer<typeof listCourseEnrollmentsResponseSchema>;
export type CourseEnrollment = ListCourseEnrollmentsResponse["data"][number];

export function getCourseEnrollmentsQueryKey(requirementId: string): string[] {
  return ["requirement-course-enrollments", requirementId];
}

interface UseGetCourseEnrollmentsOptions {
  enabled?: boolean;
}

export function useGetCourseEnrollments(
  requirementId: string,
  options: UseGetCourseEnrollmentsOptions = {}
) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: getCourseEnrollmentsQueryKey(requirementId),
    queryFn: async () => {
      const response = await get({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/requirement-course-enrollments?filter[requirementId]=${encodeURIComponent(requirementId)}`,
        responseSchema: listCourseEnrollmentsResponseSchema,
      });
      return response.data.data;
    },
    enabled,
    meta: {
      logErrorMessage: "Failed to fetch course enrollments",
    },
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });
}
